/** @type {import('./index').NetworkConfig} */
const twitch = {
  name: 'Twitch',
  sort: 8,
  baseUrl: 'https://www.twitch.tv/',
  domains: ['twitch.tv'],
  supported: false,
  color: '#9146FF',
  hasVideoContent: false,
  supportsEmbed: false,
  requiresReferrer: false,
  profileUrlPattern: /^https:\/\/(?:www\.)?twitch\.tv\/(?!account(?:\/|$|\/videos|\/clips|\/collections|\/events)|directory|friends|subscriptions|messages)([a-zA-Z0-9_.]+)\/?$/,
};

export default twitch;
